module.exports = __webpack_public_path__ + "img/smile.38427104.png";